module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "trash.b6bf9014.svg";